import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeleteEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeleteEventVO.validationSchema()
  );

  constructor(readonly value: RoomBrandOverlayDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandOverlayDeleteEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayDeleteEvent {
  roomId: RoomId;
}
